import React from 'react';

import { SectionHeadingProps } from '../types';

const SectionHeading = (props: SectionHeadingProps) => {
  const { heading, subHeading, classname = 'text-center mx-auto' } = props;
  return (
    <div className={classname}>
      <div className="xl:text-s-56 sm:text-s-28 text-s-48 text-font-500 leading-tight mb-6 font-bold">
        {heading}
      </div>
      <div className="font-light text-font-200 text-s-20 mb-12">
        {subHeading}
      </div>
    </div>
  );
};

export default SectionHeading;
